import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

/**
 * Fires a single POST /api/analytics/visit per path change.
 * Admin routes are excluded.
 */
export default function usePageTracking() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!pathname) return;
    if (pathname.startsWith("/admin")) return;
    const key = `__gec_visit_${pathname}_${new Date().toISOString().slice(0, 10)}`;
    // Fire at most once per path per calendar day per browser
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");
    api
      .post("/analytics/visit", {
        path: pathname,
        referrer: document.referrer || null,
      })
      .catch(() => {});
  }, [pathname]);
}
